// extracted by mini-css-extract-plugin
export default {"stat-card":"stats_stat-card__acKIJ"};